module.exports = "<div class=\"Info-page\">\n  <div class=\"Info-text\">\n    <h1>Ratings & Reviews</h1>\n    <p>After a tour is complete, both visitors and hosts will be reminded to rate and review their experience. Reviews are critical for helping Showaround to grow as a credible and trustworthy community and are especially valuable for locals who want to build their reputation and experience. Be honest and descriptive when writing your review - everyone appreciates a sincere and helpful opinion.</p>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/info/info_reviews.html
// module id = 984
// module chunks = 4